'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _lodash = require('lodash');

var _milanoteReselect = require('../milanoteReselect/milanoteReselect');

var _userService = require('../../user/userService');

var userService = _interopRequireWildcard(_userService);

var _elementService = require('../../element/elementService');

var elementService = _interopRequireWildcard(_elementService);

var _remoteUsersSelector = require('./remoteUsersSelector');

var _currentUserSelector = require('../../user/currentUserSelector');

var _permissionsService = require('../permissions/permissionsService');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib


// Utils


// Selectors


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchUsers: function fetchUsers(userIds) {
            return dispatch(userService.fetchUsers(userIds));
        },
        fetchElements: function fetchElements(elementIds) {
            return dispatch(elementService.fetchElements({ elementIds: elementIds, loadAncestors: true }));
        }
    };
};

/**
 * Fetch any user that is in the user store, or has permissions to the current board (but isn't in the user store).
 *
 * The latter situation could happen if a board with an ACL that contains new users is moved inside another shared
 * board, and the current user then navigates to that board.
 */
var remoteUserSelector = (0, _milanoteReselect.createShallowSelector)(_remoteUsersSelector.getTrackedUserIds, _permissionsService.currentBoardSharedUsersSelector, function (remoteUserIds, currentBoardSharedUsers) {
    return (0, _lodash.uniq)([].concat(_toConsumableArray(remoteUserIds), _toConsumableArray(currentBoardSharedUsers)));
});

var sharedUserManagerSelector = (0, _reselect.createSelector)(remoteUserSelector, _remoteUsersSelector.getRemoteCurrentlyViewedBoardIds, _currentUserSelector.isGuestSelector, function (remoteUserIds, currentlyViewedBoardIds, isGuest) {
    return {
        remoteUserIds: remoteUserIds,
        currentlyViewedBoardIds: currentlyViewedBoardIds,
        isGuest: isGuest
    };
});

/**
 * Ensures that the shared users are being fetched whenever the component is mounted or the board is changed.
 */
var RemoteUserManager = (_dec = (0, _reactRedux.connect)(sharedUserManagerSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(RemoteUserManager, _React$Component);

    function RemoteUserManager() {
        _classCallCheck(this, RemoteUserManager);

        return _possibleConstructorReturn(this, (RemoteUserManager.__proto__ || Object.getPrototypeOf(RemoteUserManager)).apply(this, arguments));
    }

    _createClass(RemoteUserManager, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                remoteUserIds = _props.remoteUserIds,
                fetchUsers = _props.fetchUsers,
                isGuest = _props.isGuest;


            if (isGuest) return;

            fetchUsers(remoteUserIds);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isGuest = nextProps.isGuest;

            if (isGuest) return;

            // Load remote users
            if (this.props.remoteUserIds !== nextProps.remoteUserIds) {
                var remoteUserIds = nextProps.remoteUserIds,
                    fetchUsers = nextProps.fetchUsers;

                fetchUsers(remoteUserIds);
            }

            if (this.props.currentlyViewedBoardIds !== nextProps.currentlyViewedBoardIds) {
                var currentlyViewedBoardIds = nextProps.currentlyViewedBoardIds,
                    fetchElements = nextProps.fetchElements;

                fetchElements(currentlyViewedBoardIds);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.Children.only(this.props.children);
        }
    }]);

    return RemoteUserManager;
}(_react2.default.Component)) || _class);


RemoteUserManager.propTypes = {
    children: _propTypes2.default.element.isRequired,
    fetchUsers: _propTypes2.default.func,
    fetchElements: _propTypes2.default.func,
    remoteUserIds: _propTypes2.default.array,
    currentlyViewedBoardIds: _propTypes2.default.array,
    isGuest: _propTypes2.default.bool
};

exports.default = RemoteUserManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/collaboration/RemoteUserManager.js
// module id = 2116
// module chunks = 0